// import React from "react";
// import {
//   IResourceComponentsProps,
//   useShow,
//   useCustom,
//   useNavigation,
// } from  "@pankod/refine-core";
// import {
//   Show,
//   Typography,
//   Stack,
//   Box,
//   Paper,
//   Grid,
//   Card,
//   Button,
//   Chip,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   CircularProgress,
//   Alert,
// } from "@pankod/refine-mui";
// import { Print, ArrowBack, School, Person, Grade } from "@mui/icons-material";
// import { IStudent } from "../../interfaces";

// interface QuizAttempt {
//     attemptNumber: number;
//     score: number | null;
//     passed: boolean;
//     isComplete: boolean;
//     completedAt: string | null;
// }

// interface BookQuiz {
//     available: boolean;
//     summary: {
//         bestScore: number;
//         hasPassed: boolean;
//     };
//     attempts: QuizAttempt[];
// }

// interface BookProgress {
//     id: string;
//     title: string; 
//     gradeLevel: number;
//     lastRead: string; 
//     gems: { 
//         total: number;
//         emerald?: number; 
//         history?: any[];
//     } | null;
//     quiz: BookQuiz;
// }

// interface StudentReportData {
//     student: {
//       name: string;
//       grade: number;
//       school: string;
//       teacher: string;
//     };
//     statistics: {
//         booksStarted: number;      
//         averageQuizScore: number;  
//         quizzesPassed: number;     
//     };
//     books: BookProgress[];
// }


// export const LibraryReportShow: React.FC<IResourceComponentsProps> = () => {
//   const { showId } = useShow<IStudent>();
//   const { list } = useNavigation();
//   
//   const { data: reportData, isLoading, error } = useCustom<StudentReportData>({
//     url: `${process.env.REACT_APP_BACKEND}admin/libraryReport/${showId}`,
//     method: "get",
//   });


//   const handleGeneratePDF = () => {
//     const token = localStorage.getItem("token");
//     const reportUrl = `${process.env.REACT_APP_BACKEND}admin/libraryReport/${showId}/pdf`;
//     
//     fetch(reportUrl, {
//       method: 'GET',
//       headers: {
//         'Authorization': `Bearer ${token}`,
//       },
//     })
//     .then(response => {
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
//       return response.text();
//     })
//     .then(htmlContent => {
//       const printWindow = window.open('', '_blank');
//       if (printWindow) {
//         printWindow.document.write(htmlContent);
//         printWindow.document.close();
//         
//         printWindow.onload = () => {
//           setTimeout(() => {
//             printWindow.print();
//           }, 500);
//         };
//       } else {
//         console.error('Failed to open print window - popup blocked?');
//       }
//     })
//     .catch(error => {
//       console.error('Error generating PDF:', error);
//     });
//   };

//   const getScoreColor = (score: number) => {
//     if (score >= 90) return 'success';
//     if (score >= 80) return 'info';
//     if (score >= 60) return 'warning';
//     return 'error';
//   };

//   const getScoreLabel = (score: number) => {
//     if (score >= 90) return 'Excellent';
//     if (score >= 80) return 'Good';
//     if (score >= 60) return 'Fair';
//     return 'Needs Improvement';
//   };
  
//   const totalGems = React.useMemo(() => {
//     if (!reportData?.data?.books) return 0;
//     return reportData.data.books.reduce((sum, book) => sum + (book.gems?.total ?? 0), 0);
//   }, [reportData]);

//   // FIX: Replaced moment.js with native Date formatting
//   const formatDate = (dateString: string) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString('en-US', {
//         month: 'short',
//         day: 'numeric',
//         year: 'numeric',
//     });
//   };
  
//     const getCurrentDate = () => {
//         return new Date().toLocaleDateString('en-US', {
//             month: 'long',
//             day: 'numeric',
//             year: 'numeric',
//         });
//     }

//   if (isLoading) {
//     return (
//       <Show>
//         <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
//           <CircularProgress />
//           <Typography variant="h6" sx={{ ml: 2 }}>
//             Loading student report...
//           </Typography>
//         </Box>
//       </Show>
//     );
//   }

//   if (error || !reportData?.data) {
//     return (
//       <Show>
//         <Alert severity="error">
//           Failed to load student report. Please try again.
//         </Alert>
//       </Show>
//     );
//   }

//   const report = reportData.data;

//   return (
//     <Show
//       title="Library Reading Report"
//       headerButtons={
//         <Stack direction="row" spacing={2}>
//           <Button
//             variant="outlined"
//             startIcon={<ArrowBack />}
//             onClick={() => list("libraryReport")}
//           >
//             Back to Reports
//           </Button>
//           <Button
//             variant="contained"
//             startIcon={<Print />}
//             onClick={handleGeneratePDF}
//           >
//             Generate PDF
//           </Button>
//         </Stack>
//       }
//     >
//       <Grid container spacing={3}>
//         {/* Student Information */}
//         <Grid item xs={12}>
//           <Paper sx={{ p: 3 }}>
//             <Typography variant="h5" gutterBottom>
//                Reading Progress Report
//             </Typography>
//             
//             <Grid container spacing={3} sx={{ mt: 1 }}>
//               <Grid item xs={12} md={6}>
//                 <Stack spacing={2}>
//                   <Box display="flex" alignItems="center" gap={1}>
//                     <Person color="primary" />
//                     <Typography variant="h6">{report.student.name}</Typography>
//                   </Box>
//                   <Box display="flex" alignItems="center" gap={1}>
//                     <Grade color="primary" />
//                     <Typography>Grade {report.student.grade}</Typography>
//                   </Box>
//                   <Box display="flex" alignItems="center" gap={1}>
//                     <School color="primary" />
//                     <Typography>{report.student.school}</Typography>
//                   </Box>
//                   {report.student.teacher && (
//                     <Typography variant="body2" color="textSecondary">
//                       Teacher: {report.student.teacher}
//                     </Typography>
//                   )}
//                 </Stack>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
//                   Report generated on {getCurrentDate()}
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* Statistics Cards */}
//         <Grid item xs={12}>
//           <Grid container spacing={2}>
//             <Grid item xs={6} md={3}>
//               <Card sx={{ p: 2, textAlign: 'center', bgcolor: 'primary.50' }}>
//                 <Typography variant="h4" color="primary">
//                   {report.statistics.booksStarted} 
//                 </Typography>
//                 <Typography variant="body2">Books Read</Typography>
//                 <Typography variant="caption" color="textSecondary">(started)</Typography>
//               </Card>
//             </Grid>
//             <Grid item xs={6} md={3}>
//               <Card sx={{ p: 2, textAlign: 'center', bgcolor: 'warning.50' }}>
//                 <Typography variant="h4" color="warning.main">
//                   💎 {totalGems}
//                 </Typography>
//                 <Typography variant="body2">Total Gems</Typography>
//                 <Typography variant="caption" color="textSecondary">earned</Typography>
//               </Card>
//             </Grid>
//             <Grid item xs={6} md={3}>
//               <Card sx={{ p: 2, textAlign: 'center', bgcolor: 'success.50' }}>
//                 <Typography variant="h4" color="success.main">
//                   {report.statistics.averageQuizScore}%
//                 </Typography>
//                 <Typography variant="body2">Average Score</Typography>
//                 <Typography variant="caption" color="textSecondary">quiz performance</Typography>
//               </Card>
//             </Grid>
//             <Grid item xs={6} md={3}>
//               <Card sx={{ p: 2, textAlign: 'center', bgcolor: 'info.50' }}>
//                 <Typography variant="h4" color="info.main">
//                   {report.statistics.quizzesPassed}
//                 </Typography>
//                 <Typography variant="body2">Quizzes Passed</Typography>
//                 <Typography variant="caption" color="textSecondary">successful attempts</Typography>
//               </Card>
//             </Grid>
//           </Grid>
//         </Grid>

//         {/* Books Table */}
//         <Grid item xs={12}>
//           <Paper sx={{ p: 3 }}>
//             <Typography variant="h6" gutterBottom>
//                Books Read & Quiz Results
//             </Typography>
//             
//             {report.books.length === 0 ? (
//               <Alert severity="info" sx={{ mt: 2 }}>
//                 No books with quiz attempts found for this student.
//               </Alert>
//             ) : (
//               <TableContainer sx={{ mt: 2 }}>
//                 <Table>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell><strong>Book Title</strong></TableCell>
//                       <TableCell align="center"><strong>Grade</strong></TableCell>
//                       <TableCell align="center"><strong>Best Score</strong></TableCell>
//                       <TableCell align="center"><strong>Status</strong></TableCell>
//                       <TableCell align="center"><strong>Gems</strong></TableCell>
//                       <TableCell align="center"><strong>Last Read</strong></TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {report.books.map((book) => {
//                         const score = book.quiz?.summary?.bestScore ?? 0;
//                         const passed = book.quiz?.summary?.hasPassed ?? false;
//                         const gems = book.gems?.total ?? 0;

//                         return (
//                       <TableRow key={book.id} hover>
//                         <TableCell>
//                           <Typography variant="subtitle2">
//                             {book.title}
//                           </Typography>
//                         </TableCell>
//                         <TableCell align="center">
//                           <Chip 
//                             label={`Grade ${book.gradeLevel}`} 
//                             size="small" 
//                             variant="outlined"
//                           />
//                         </TableCell>
//                         <TableCell align="center">
//                           {book.quiz?.available ? (
//                             <>
//                               <Chip
//                                   label={`${score}%`}
//                                   color={getScoreColor(score)}
//                                   size="small"
//                               />
//                               <Typography variant="caption" display="block" color="textSecondary">
//                                   {getScoreLabel(score)}
//                               </Typography>
//                             </>
//                           ) : (
//                             <Typography variant="caption" color="textSecondary">No Quiz</Typography>
//                           )}
//                         </TableCell>
//                         <TableCell align="center">
//                           {book.quiz?.available ? (
//                             <Chip
//                                 label={passed ? '✓ Passed' : '✗ Failed'}
//                                 color={passed ? 'success' : 'error'}
//                                 size="small"
//                             />
//                           ) : (
//                              <Chip label="N/A" size="small" />
//                           )}
//                         </TableCell>
//                         <TableCell align="center">
//                           <Typography variant="subtitle2">
//                             💎 {gems}
//                           </Typography>
//                         </TableCell>
//                 _        <TableCell align="center">
//                           <Typography variant="body2">
//                             {formatDate(book.lastRead)}
//                           </Typography>
//                         </TableCell>
//                       </TableRow>
//                        )
//                     })}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             )}
//           </Paper>
//         </Grid>

//         {/* Report Notes */}
//         <Grid item xs={12}>
//           <Paper sx={{ p: 2, bgcolor: 'grey.50' }}>
//             <Typography variant="caption" color="textSecondary">
//               <strong>Report Notes:</strong> This report includes all books the student has started. Quiz data is shown where available.
//             </Typography>
//           </Paper>
//         </Grid>
//       </Grid>
//     </Show>
//   );
// };

import React, { useState, useMemo } from "react";
import {
  IResourceComponentsProps,
  useShow,
  useCustom,
  useNavigation,
} from "@pankod/refine-core";
import {
  Show,
  Typography,
  Stack,
  Box,
  Paper,
  Grid,
  Card,
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
  IconButton,
  Tooltip,
} from "@pankod/refine-mui";
import {
  Print,
  ArrowBack,
  School,
  Person,
  Grade,
  ArrowUpward,
  ArrowDownward,
} from "@mui/icons-material";

// --- INTERFACES (Enhanced & Type-Safe) ---

interface GemDetail {
  name: string;
  type: string;
  count: number;
}

interface BookProgress {
  bookTitle: string;
  gradeLevel: number;
  coverImage?: string;
  score: number;
  passed: boolean;
  quizComplete: boolean;
  bookComplete: boolean;
  gems: number;
  gemDetails: GemDetail[];
  attemptDate: string;
}

interface StudentInfo {
  name: string;
  grade: number;
  school: string;
  teacher?: string;
}

interface ReportSummary {
  totalBooks: number;
  totalGems: number;
  averageScore: number;
  booksPassedQuiz: number;
  booksCompleted: number;
  quizzesCompleted: number;
}

interface StudentReportData {
  student: StudentInfo;
  summary: ReportSummary;
  books: BookProgress[];
  generatedDate: string;
  generatedBy: string;
}

// --- SORTING LOGIC HOOK ---

type SortDirection = "asc" | "desc" | null;
type SortConfig = {
  key: keyof BookProgress;
  direction: SortDirection;
};

const useSortableData = <T,>(items: T[], config: SortConfig | null = null) => {
  const [sortConfig, setSortConfig] = useState<SortConfig | null>(config);

  const sortedItems = useMemo(() => {
    if (!sortConfig) return items;

    const { key, direction } = sortConfig;
    return [...items].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [items, sortConfig]);

  const requestSort = (key: keyof BookProgress) => {
    let direction: SortDirection = "asc";
    if (sortConfig && sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    } else if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === "desc"
    ) {
      direction = null;
    }
    setSortConfig(direction ? { key, direction } : null);
  };

  return { items: sortedItems, requestSort, sortConfig };
};

// --- MAIN COMPONENT ---

export const LibraryReportShow: React.FC<IResourceComponentsProps> = () => {
  const { showId } = useShow();
  const { list } = useNavigation();

  const { data: reportData, isLoading, error } = useCustom<StudentReportData>({
    url: `${process.env.REACT_APP_BACKEND}admin/libraryReport/${showId}`,
    method: "get",
  });

  // --- SORT HOOK INIT ---
  const { items: sortedBooks, requestSort, sortConfig } = useSortableData(
    reportData?.data?.books || []
  );

  // --- PDF GENERATION (Enhanced) ---
  const getPdfScoreClass = (score: number): string => {
    if (score >= 90) return "score-excellent";
    if (score >= 80) return "score-good";
    if (score >= 60) return "score-fair";
    return "score-poor";
  };

  const generatePdfHtml = (report: StudentReportData) => {
    const { student, summary, books, generatedDate, generatedBy } = report;

    const booksHtml = books.length === 0
      ? `<p style="text-align: center; color: #666; font-style: italic; padding: 40px;">No books with quiz attempts found.</p>`
      : `<table class="books-table">
            <thead>
                <tr>
                    <th style="width: 35%">Book Title</th>
                    <th style="width: 10%">Grade</th>
                    <th style="width: 10%">Quiz Score</th>
                    <th style="width: 10%">Quiz Complete</th>
                    <th style="width: 10%">Passed</th>
                    <th style="width: 15%">Gems Earned</th>
                    <th style="width: 10%">Date Completed</th>
                </tr>
            </thead>
            <tbody>
                ${books
                  .map((book) => {
                    const attemptDate = book.attemptDate
                      ? new Date(book.attemptDate).toLocaleDateString()
                      : "N/A";
                    const gemDetailsHtml =
                      book.gemDetails && book.gemDetails.length > 0
                        ? `<br><small style="color: #666; font-size: 10px;">${book.gemDetails
                            .map((gem) => `${gem.type} (${gem.count})`)
                            .join(", ")}</small>`
                        : "";

                    return `
                    <tr>
                        <td><strong>${book.bookTitle}</strong></td>
                        <td>Grade ${book.gradeLevel}</td>
                        <td>
                            <span class="score-badge ${getPdfScoreClass(
                              book.score
                            )}">${book.score}%</span>
                        </td>
                        <td>
                            <span class="passed-badge ${
                              book.quizComplete
                                ? "passed-complete"
                                : "passed-incomplete"
                            }">${book.quizComplete ? "✓ Yes" : "✗ No"}</span>
                        </td>
                        <td>
                            <span class="passed-badge ${
                              book.passed ? "passed-yes" : "passed-no"
                            }">${book.passed ? "✓ Yes" : "✗ No"}</span>
                        </td>
                        <td>
                            <span class="gems-badge">💎 ${book.gems}</span>
                            ${gemDetailsHtml}
                        </td>
                        <td>${attemptDate}</td>
                    </tr>`;
                  })
                  .join("")}
            </tbody>
        </table>`;

    return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Reading Progress Report - ${student.name}</title>
        <style>
            @media print {
                body { margin: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                .no-print { display: none; }
                .page-break { page-break-before: always; }
            }
            body { font-family: 'Arial', sans-serif; line-height: 1.4; color: #333; max-width: 800px; margin: 0 auto; padding: 20px; background: white; }
            .header { text-align: center; border-bottom: 3px solid #4CAF50; padding-bottom: 20px; margin-bottom: 30px; }
            .header h1 { color: #2E7D32; margin: 0; font-size: 28px; font-weight: bold; }
            .header .subtitle { color: #666; font-size: 16px; margin-top: 5px; }
            .student-info { background: #f8f9fa; border-radius: 8px; padding: 20px; margin-bottom: 25px; border-left: 4px solid #4CAF50; }
            .student-info h2 { margin: 0 0 15px 0; color: #2E7D32; font-size: 20px; }
            .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }
            .info-item { display: flex; justify-content: space-between; padding: 8px 0; border-bottom: 1px solid #e0e0e0; }
            .info-label { font-weight: bold; color: #555; }
            .info-value { color: #333; }
            .summary-stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 15px; margin-bottom: 30px; }
            .stat-card { background: linear-gradient(135deg, #4CAF50, #45a049); color: white; padding: 20px; border-radius: 8px; text-align: center; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
            .stat-number { font-size: 24px; font-weight: bold; display: block; }
            .stat-label { font-size: 12px; opacity: 0.9; margin-top: 5px; }
            .books-section h2 { color: #2E7D32; border-bottom: 2px solid #4CAF50; padding-bottom: 10px; margin-bottom: 20px; }
            .books-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }
            .books-table th { background: #4CAF50; color: white; padding: 12px 8px; text-align: left; font-weight: bold; font-size: 14px; }
            .books-table td { padding: 12px 8px; border-bottom: 1px solid #e0e0e0; font-size: 13px; }
            .books-table tr:nth-child(even) { background: #f8f9fa; }
            .books-table tr:hover { background: #e8f5e8; }
            .score-badge { display: inline-block; padding: 4px 8px; border-radius: 12px; font-weight: bold; font-size: 12px; }
            .score-excellent { background: #4CAF50; color: white; }
            .score-good { background: #8BC34A; color: white; }
            .score-fair { background: #FFC107; color: black; }
            .score-poor { background: #F44336; color: white; }
            .gems-badge { display: inline-block; background: #FFD700; color: #333; padding: 4px 8px; border-radius: 12px; font-weight: bold; font-size: 12px; }
            .passed-badge { display: inline-block; padding: 4px 8px; border-radius: 12px; font-weight: bold; font-size: 11px; }
            .passed-yes { background: #4CAF50; color: white; }
            .passed-complete { background: #68b9e2e2; color: white; }
            .passed-incomplete { background: #d45e81e2; color: white; }
            .passed-no { background: #F44336; color: white; }
            .footer { margin-top: 40px; padding-top: 20px; border-top: 1px solid #e0e0e0; text-align: center; color: #666; font-size: 12px; }
            .print-button { background: #4CAF50; color: white; border: none; padding: 12px 24px; border-radius: 6px; cursor: pointer; font-size: 16px; margin-bottom: 20px; }
            .print-button:hover { background: #45a049; }
            @media (max-width: 600px) {
                .summary-stats { grid-template-columns: repeat(2, 1fr); }
                .info-grid { grid-template-columns: 1fr; }
                .books-table { font-size: 11px; }
                .books-table th, .books-table td { padding: 8px 4px; }
            }
        </style>
    </head>
    <body>
        <button class="print-button no-print" onclick="window.print()">🖨️ Print Report</button>
        <div class="header">
            <h1>Reading Progress Report</h1>
            <div class="subtitle">Online Library Reading Assessment</div>
        </div>
        <div class="student-info">
            <h2>👤 Student Information</h2>
            <div class="info-grid">
                <div class="info-item"><span class="info-label">Student Name:</span><span class="info-value">${student.name}</span></div>
                <div class="info-item"><span class="info-label">Grade Level:</span><span class="info-value">Grade ${student.grade}</span></div>
                <div class="info-item"><span class="info-label">School:</span><span class="info-value">${student.school}</span></div>
                <div class="info-item"><span class="info-label">Teacher:</span><span class="info-value">${student.teacher || "N/A"}</span></div>
            </div>
        </div>
        <div class="summary-stats">
            <div class="stat-card"><span class="stat-number">${summary.totalBooks}</span><div class="stat-label">Books Read</div></div>
            <div class="stat-card"><span class="stat-number">${summary.totalGems}</span><div class="stat-label">Total Gems<br>Earned</div></div>
            <div class="stat-card"><span class="stat-number">${summary.averageScore}%</span><div class="stat-label">Average<br>Quiz Score</div></div>
            <div class="stat-card"><span class="stat-number">${summary.booksPassedQuiz}</span><div class="stat-label">Quizzes<br>Passed</div></div>
        </div>
        <div class="books-section">
            <h2>📖 Books Read & Quiz Results</h2>
            ${booksHtml}
        </div>
        <div class="footer">
            <p><strong>Report Generated:</strong> ${generatedDate} | <strong>Generated By:</strong> ${generatedBy}</p>
            <p>Read 21 © 2025.</p>
        </div>
    </body>
    </html>`;
  };

  const handleGeneratePDF = () => {
    if (!reportData?.data) {
      console.error("Report data is not available to generate PDF.");
      return;
    }
    const htmlContent = generatePdfHtml(reportData.data);
    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.write(htmlContent);
      printWindow.document.close();
    } else {
      alert("Popup blocked. Please allow popups to generate PDF.");
    }
  };

  // --- UI HELPERS ---
  const getScoreColor = (score: number) => {
    if (score >= 90) return "success";
    if (score >= 80) return "info";
    if (score >= 60) return "warning";
    return "error";
  };

  const getScoreLabel = (score: number) => {
    if (score >= 90) return "Excellent";
    if (score >= 80) return "Good";
    if (score >= 60) return "Fair";
    return "Needs Improvement";
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const getCurrentDate = () => {
    return new Date().toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  const getSortIcon = (column: keyof BookProgress) => {
    if (!sortConfig || sortConfig.key !== column) return null;
    return sortConfig.direction === "asc" ? (
      <ArrowUpward fontSize="small" />
    ) : (
      <ArrowDownward fontSize="small" />
    );
  };

  // --- LOADING / ERROR STATES ---
  if (isLoading) {
    return (
      <Show>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="400px"
          flexDirection="column"
          gap={2}
        >
          <CircularProgress size={48} />
          <Typography variant="h6">Loading student report...</Typography>
        </Box>
      </Show>
    );
  }

  if (error || !reportData?.data) {
    return (
      <Show>
        <Alert severity="error" sx={{ mt: 3 }}>
          ❌ Failed to load student report. Please try again.
        </Alert>
      </Show>
    );
  }

  const report = reportData.data;

  return (
    <Show
      title="Library Reading Report"
      headerButtons={
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => list("libraryReport")}
            sx={{ borderRadius: 2 }}
          >
            Back to Reports
          </Button>
          <Button
            variant="contained"
            startIcon={<Print />}
            onClick={handleGeneratePDF}
            sx={{
              borderRadius: 2,
              background: "linear-gradient(45deg, #4CAF50, #45a049)",
              "&:hover": {
                background: "linear-gradient(45deg, #45a049, #3d8b40)",
              },
            }}
          >
            Generate PDF
          </Button>
        </Stack>
      }
    >
      <Grid container spacing={3}>
        {/* Student Info Card */}
        <Grid item xs={12}>
          <Paper
            sx={{
              p: 3,
              borderRadius: 3,
              boxShadow: 3,
              background: "linear-gradient(to right, #f0f7f4, #e3f2fd)",
            }}
          >
            <Typography variant="h5" gutterBottom fontWeight="bold">
              Reading Progress Report
            </Typography>
            <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <Box display="flex" alignItems="center" gap={1.5}>
                  <Typography variant="h6" fontWeight="600">
                    Student Name:
                  </Typography>
                  <Typography variant="h6" fontWeight="500">
                    {report.student.name}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1.5}>
                  <Typography variant="h6" fontWeight="600">
                    Grade Level:
                  </Typography>
                  <Typography variant="h6" fontWeight="500">
                    {report.student.grade}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1.5}>
                  <Typography variant="h6" fontWeight="600">
                    School:
                  </Typography>
                  <Typography variant="h6" fontWeight="500">
                    {report.student.school}
                  </Typography>
                </Box>

                {report.student.teacher && (
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Typography variant="h6" fontWeight="600">
                      Teacher:
                    </Typography>
                    <Typography variant="h6" fontWeight="500">
                      {report.student.teacher}
                    </Typography>
                  </Box>
                )}
              </Stack>
            </Grid>
          </Grid>

            
          </Paper>
        </Grid>

        {/* Stats Cards */}
        <Grid item xs={12}>
          <Grid container spacing={2.5}>
            {[
              {
                label: "Books Read",
                value: report.summary.totalBooks,
                color: "primary",
                icon: "📚",
                caption: "with Quiz started",
              },
              {
                label: "Total Gems",
                value: `💎 ${report.summary.totalGems}`,
                color: "warning",
                icon: "💎",
                caption: "earned",
              },
              {
                label: "Avg. Score",
                value: `${report.summary.averageScore}%`,
                color: "success",
                icon: "📈",
                caption: "quiz performance",
              },
              {
                label: "Quizzes Passed",
                value: report.summary.booksPassedQuiz,
                color: "info",
                icon: "✅",
                caption: "successful attempts",
              },
            ].map((stat, idx) => (
              <Grid item xs={6} md={3} key={idx}>
                <Card
                  sx={{
                    p: 2.5,
                    textAlign: "center",
                    bgcolor: `${stat.color}.50`,
                    borderRadius: 2.5,
                    transition: "transform 0.2s ease-in-out",
                    "&:hover": { transform: "translateY(-4px)" },
                    boxShadow: 2,
                  }}
                >
                  <Typography variant="h4" color={`${stat.color}.main`} fontWeight="bold">
                    {stat.value}
                  </Typography>
                  <Typography variant="body2" fontWeight="500">
                    {stat.label}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {stat.caption}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Books Table with Sortable Headers */}
        <Grid item xs={12}>
          <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 2 }}>
            <Typography variant="h6" gutterBottom fontWeight="600">
              📖 Books Read & Quiz Results
            </Typography>

            {report.books.length === 0 ? (
              <Alert severity="info" sx={{ mt: 2, borderRadius: 2 }}>
               No books with quiz attempts found for this student.
              </Alert>
            ) : (
              <TableContainer sx={{ mt: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <strong>Book Title</strong>
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Sort by Grade Level">
                          <span
                            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                            onClick={() => requestSort("gradeLevel")}
                          >
                            <strong>Grade</strong>
                            {getSortIcon("gradeLevel")}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Sort by Quiz Score">
                          <span
                            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                            onClick={() => requestSort("score")}
                          >
                            <strong>Quiz Score</strong>
                            {getSortIcon("score")}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                          <strong>Quiz Complete</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Status</strong>
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Sort by Gems Earned">
                          <span
                            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                            onClick={() => requestSort("gems")}
                          >
                            <strong>Gems</strong>
                            {getSortIcon("gems")}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Sort by Attempt Date">
                          <span
                            style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                            onClick={() => requestSort("attemptDate")}
                          >
                            <strong>Date</strong>
                            {getSortIcon("attemptDate")}
                          </span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedBooks.map((book, index) => (
                      <TableRow
                        key={`${book.bookTitle}-${index}`}
                        hover
                        sx={{
                          transition: "background-color 0.2s ease",
                          "&:hover": {
                            backgroundColor: "rgba(76, 175, 80, 0.08) !important",
                          },
                        }}
                      >
                        <TableCell>
                          <Typography variant="subtitle2" fontWeight="500">
                            {book.bookTitle}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={`Grade ${book.gradeLevel}`}
                            size="small"
                            variant="outlined"
                            color="primary"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={`${book.score}%`}
                            color={getScoreColor(book.score)}
                            size="small"
                            sx={{ fontWeight: "bold" }}
                          />
                          <Typography variant="caption" display="block" color="textSecondary" mt={0.5}>
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={book.quizComplete? "✓ Yes" : "✗ No"}
                            color={book.quizComplete ? "success" : "error"}
                            size="small"
                            sx={{ fontWeight: "bold" }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={book.passed ? "✓ Yes" : "✗ No"}
                            color={book.passed ? "success" : "error"}
                            size="small"
                            sx={{ fontWeight: "bold" }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="subtitle2" fontWeight="600">
                            💎 {book.gems}
                          </Typography>
                          {book.gemDetails && book.gemDetails.length > 0 && (
                            <Typography variant="caption" display="block" color="textSecondary" mt={0.5}>
                              {book.gemDetails.map((gem) => `${gem.type} (${gem.count})`).join(", ")}
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body2" fontWeight="500">
                            {formatDate(book.attemptDate)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </Grid>

      </Grid>
    </Show>
  );
};